import { ProcessTemplateDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ProcessInputFields, StepTemplate, Template, TemplateInputCategory } from '../domain'

export const useTemplate = (id: string | undefined) => {
  const category = id === 'custom' ? 'default' : id

  const { data, loading } = useQuery(ProcessTemplateDocument, {
    variables: { id: category || '' },
    skip: !id,
  })

  const stepsString = data?.processes.template?.steps?.at(0)
  const processInputFieldsString = data?.processes.template?.processInputFields?.at(0)
  const dataCollectionInputCategoriesString =
    data?.processes.template?.dataCollectionInputCategories?.at(0)

  const steps: StepTemplate[] = stepsString ? JSON.parse(stepsString) : []
  const processInputFields: ProcessInputFields[] = processInputFieldsString
    ? JSON.parse(processInputFieldsString)
    : []
  const dataCollectionInputCategories: TemplateInputCategory[] = dataCollectionInputCategoriesString
    ? JSON.parse(dataCollectionInputCategoriesString)
    : []

  const dataTemplate = data?.processes.template

  const template: Template | undefined = dataTemplate
    ? {
        ...dataTemplate,
        steps: steps,
        processInputFields,
        dataCollectionInputCategories,
      }
    : undefined

  return {
    loading: loading,
    template,
    error: false,
  }
}
